(() => {
  const styleFinder = () => {
    const finder = document.getElementById('gtfo-vehicle-finder');
    if (!finder || finder.dataset.labelObserver === 'ready') return;
    finder.dataset.labelObserver = 'ready';
    const updateLabel = () => {
      const button = finder.querySelector('.easysearch-btn-search');
      if (button && button.textContent.trim() !== finder.dataset.searchLabel) {
        button.textContent = finder.dataset.searchLabel;
      }
    };
    new MutationObserver(updateLabel).observe(finder, { childList: true, subtree: true });
    updateLabel();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', styleFinder, { once: true });
  } else {
    styleFinder();
  }
  document.addEventListener('shopify:section:load', styleFinder);
})();
